import styles from './ProcessUIUX.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

const Process: React.FC = () => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.wrapper} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <h2 className={styles.sectionTitle}>制作プロセス</h2>
      <p className={styles.sectionRead}>
        制作プロセスは、大きく「現状分析・コンセプト定義」「ベース設計」「構造・骨格設計」の3つのステップに分かれます。
        <br />
        各工程でUX設計、UI設計、ビジュアルデザイン、デザインシステム構築を柔軟に行き来しながら、プロダクトの完成度を高めていきます。
      </p>
      <div className={styles.process}>
        <figure className={styles.process__img}>
          <img
            src="/img/services/uxui_process_pc.webp"
            alt="現状分析・コンセプト定義/ベース設計/構造・骨格設計"
            className={styles.process__img__pc}
            loading="lazy"
          />
          <img
            src="/img/services/uxui_process_sp.webp"
            alt="現状分析・コンセプト定義/ベース設計/構造・骨格設計"
            className={styles.process__img__sp}
            loading="lazy"
          />
        </figure>
      </div>
    </section>
  )
}

export default Process
